import { 
  Typography, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper 
} from '@mui/material';
import CodeBlock from '../../CodeBlock';

function GetStatementByIdentifiers() {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography variant="body1">
        Retrieve complete statement details using official EUDR reference and verification numbers.<br/>
        Full data includes product information, operator details, and submission metadata.<br/>
        Supports GET and POST requests.
      </Typography>
      
      <Typography variant="h6" sx={{ mt: 2 }}>
        Endpoint
      </Typography>
      <CodeBlock code="GET /api/eudr/dds/statement?referenceNumber={ref_number}&verificationNumber={verification_number}" />
      <CodeBlock code="POST /api/eudr/dds/statement" />

      <Typography variant="h6" sx={{  mt: 2 }}>
        Request Body (<small>POST</small>)
      </Typography>
      <CodeBlock 
        code={`{
    "referenceNumber": "25HRYVJNLEO828",
    "verificationNumber": "WOHYRNOQ"
}`} 
      />

      <Typography variant="h6" sx={{ mt: 2 }}>
        Response
      </Typography>
      <CodeBlock 
        code={`{
    "status": "success",
    "httpStatus": 200,
    "data": [
        {
            "referenceNumber": "25HRYVJNLEO828",
            "activityType": "DOMESTIC",
            "status": {
                "status": "AVAILABLE",
                "date": "2025-03-19T19:50:01.000"
            },
            "operator": {
                "name": "TEST COMPANY",
                "country": "FR"
            },
            "commodities": {
                "position": "1",
                "descriptors": {
                    "descriptionOfGoods": "here is the description of goods",
                    "goodsMeasure": {
                        "volume": "20.00",
                        "netWeight": "40.000",
                        "supplementaryUnit": "10",
                        "supplementaryUnitQualifier": "MTQ"
                    }
                },
                "hsHeading": "1806",
                "speciesInfo": {
                    "scientificName": "Test",
                    "commonName": "Test"
                },
                "producers": {
                    "country": "FR",
                    "geometryGeojson": "eyJ0eXBlIjoiRmVhdHVyZUNvbGxlY3Rpb24iLCJmZWF0dXJlcyI6W3sidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7IlByb2R1Y3Rpb25QbGFjZSI6IkZhcm0gMSIsIkFyZWEiOjExODY3ODUuNjh9LCJnZW9tZXRyeSI6eyJ0eXBlIjoiUG9seWdvbiIsImNvb3JkaW5hdGVzIjpbW1szLjUzNzU5OCw0NC44NDAyOTFdLFs0Ljg1NTk1Nyw0Ni4zNzcyNTRdLFs1LjQyNzI0Niw0NC45NjQ3OThdLFszLjUzNzU5OCw0NC44NDAyOTFdXV19fV19"
                }
            }
        }
    ]
}`} 
      />

      <Typography variant="h6" sx={{ mt: 2 }}>
        Response Codes
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>200</TableCell>
              <TableCell>Request successful</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>400</TableCell>
              <TableCell>Bad request - missing or invalid parameters</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>401</TableCell>
              <TableCell>Unauthorized - invalid credentials</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>404</TableCell>
              <TableCell>Statement not found</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>500</TableCell>
              <TableCell>Server error</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h6" sx={{ mt: 2 }}>
        Access Requirements
      </Typography>
      <ul>
        <li><Typography variant="body2">Statement must be in "Available" status</Typography></li>
        <li><Typography variant="body2">Verification number from original submission</Typography></li>
        <li><Typography variant="body2">Recent authentication token required</Typography></li>
      </ul>
    </Box>
  );
}

export default GetStatementByIdentifiers; 